import { createQueryStringSerializer } from '@/scopes/common/infrastructure/query-strings/queryStringSerializer'
import { FilterSelection } from '@/scopes/prices/domain/filters/types'
import {
  createPricesFiltersParserWithInitState,
} from '@/scopes/prices/infrastructure/parser/pricesFilterParserWithInitState'
import {
  createRoomsParticipantDistributionMapper,
} from '@/scopes/search/search/infrastructure/api/filtersSelectionMapper/mappers/roomsParticipantDistributionMapper'

export function createFilterQueryStringSerializer(parserDependencies?: {
  roomsParticipantDistributionMapper?: ReturnType<typeof createRoomsParticipantDistributionMapper>
  defaultSelection?: FilterSelection
}) {
  return createQueryStringSerializer({
    parser: createPricesFiltersParserWithInitState(parserDependencies),
  })
}

export default createFilterQueryStringSerializer()
